import { Observable, Subscribable } from "knockout";

const emojione = require('emojione');

const unicodePattern = /png\/(.*?)\.png/;

export interface EmojisPickerEmojiConfig {
    title?: string
    unicode: string
}

export default class EmojisPickerEmoji {
    title: Observable<string>
    unicode: Observable<string>

    code: Subscribable<string | undefined>
    url: Subscribable<string>

    static fromURL(url: string) {
        const match = unicodePattern.exec(url);

        if (match != undefined)
            return new EmojisPickerEmoji({ unicode: match[1] });
    }

    constructor(data: EmojisPickerEmojiConfig) {
        this.title = ko.observable(data.title ?? '');
        this.unicode = ko.observable(data.unicode);

        this.code = this.unicode.pluck(unicode => _(emojione.emojioneList).findKey(codes => _(codes).contains(unicode)));
        this.url = this.unicode.pluck(unicode => `${settings.emojioneIconsURL}/${unicode}.png`);
    }
}